var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_15888",
    "data-name": "Group 15888",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.486,
    height: 15.486,
    viewBox: "0 0 15.486 15.486",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15889",
    "data-name": "Group 15889",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11408",
    "data-name": "Path 11408",
    d: "M14.986,7.743A7.243,7.243,0,1,1,7.743.5,7.243,7.243,0,0,1,14.986,7.743Z",
    transform: "translate(-0.5 -0.5)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15897",
    "data-name": "Group 15897",
    transform: "translate(0.186 0.317)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11410",
    "data-name": "Path 11410",
    d: "M10.922,3.061,3.193,10.79",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11411",
    "data-name": "Path 11411",
    d: "M3.193,3.061l7.729,7.73",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactive);
export default __webpack_public_path__ + "static/media/deactive.ea4d42b6567724403ee86c8be6c9ddf5.svg";
export { ForwardRef as ReactComponent };